<template>
    <div>
        <x-modal
            :wWidth="1080"
            v-if="isVisible"
            @cancel="requestVideoCallModalClose"
            @close="requestVideoCallModalClose"
            @ok="requestVideoCallModalSubmit"
            :draggable="true"
            :resizable="true"
            :loading="loading"
            :okDisabled="requestvideoCallModalButtonDisabled"
            okText="Send Link"
        >
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">
                Send Video Link
            </div>

            <div class="container">
                <el-form label-width="140px">

                    <email-sending-options></email-sending-options>

                    <email-recipients
                        :application-id="applicationId"
                        v-if="emailBuilder.sendEmail || emailBuilder.sendSms"
                        :recipientType="recipientTypes"
                        :autoSelectType="recipientTypes"
                        :recipientAllowCreate="false"
                        :hideCC="!emailBuilder.sendEmail ? true : false"
                        :hideBCC="!emailBuilder.sendEmail ? true : false"
                        :loadVideoCallRecipients="applicants"
                    ></email-recipients>

                    <email-task v-model="emailBuilder.task"></email-task>

                    <el-divider
                        v-if="!_.isEmpty(emailBuilder.recipients) && (emailBuilder.sendEmail || emailBuilder.sendSms)"></el-divider>

                    <email-markup-multi
                        class="mb-3"
                        v-if="!_.isEmpty(emailBuilder.recipients) && (emailBuilder.sendEmail || emailBuilder.sendSms)"
                        action="video-call"
                        :application-id="applicationId"
                    ></email-markup-multi>
                </el-form>
            </div>
        </x-modal>
    </div>
</template>

<script>
import EmailSendingOptions from "@ambition/components/messages/EmailSendingOptions.vue"
import EmailRecipients from "@ambition/components/messages/EmailRecipients"
import EmailAttachments from "@ambition/components/messages/EmailAttachments"
import EmailMarkupMulti from "@ambition/components/messages/EmailMarkupMulti"
import EmailTask from "@ambition/components/messages/EmailTask"
import {mapGetters, mapState} from "vuex"

export default {
    name: "BuilderVideoCallModal",
    props: {
        visible: {
            required: true,
            type: Boolean,
        },
        loadStore: {
            required: true,
            type: Boolean,
        },
        applicants: {
            required: true,
            type: Array,
        },
        applicationId: {
            type: [Number, String],
            required: true,
        },
    },
    components: {
        EmailSendingOptions,
        EmailRecipients,
        EmailAttachments,
        EmailMarkupMulti,
        EmailTask,
    },
    watch: {
        visible() {
            this.isVisible = this.visible
        },
        loadStore: {
            handler(val) {
                if (val) {
                    console.log('loadStore ', this.loadStore, this.applicationId)
                    this.$store.dispatch("builderEmail/resetEmail").then(response => {
                        this.emailBuilder.applicationId = Number(this.applicationId)
                        this.$store.dispatch('builderEmail/fetchEmailRecipients', {applicationId: Number(this.applicationId)})
                    })
                    this.$store.dispatch("builderEmail/setAllEmailTemplates").then((res) => {
                        this.emailTemplatesLoading = false
                    })
                    this.$store.dispatch("builderEmail/setAllSmsTemplates").then((res) => {
                        this.smsTemplatesLoading = false
                    })
                }
            },
            immediate: true,
        }
    },
    data() {
        return {
            isVisible: false,
            loading: false,
            recipientTypes: ["applicant"],
        }
    },
    mounted() {
    },
    activated() {
    },
    computed: {
        ...mapGetters({
            emailBuilder: "builderEmail/getEmail",
            templatesLoaded: "builderEmail/checkTemplatesLoaded",
        }),
        requestvideoCallModalButtonDisabled() {
            if (!this.templatesLoaded) return true
            if (!this.emailBuilder.sendEmail && !this.emailBuilder.sendSms) return true
            if (this.emailBuilder.delaySending && !this.emailBuilder.sendAt) return true
            if (_.size(this.emailBuilder.recipients) >= 1 && !this.loading) return false
            return true
        },
    },
    methods: {
        requestPrivacyConsentModalOpen() {
            this.$store.dispatch("builderEmail/resetEmail")
            this.loading = false
            this.isVisible = true
        },

        requestVideoCallModalClose() {
            this.$store.dispatch("builderEmail/resetEmail")
            this.loading = false
            this.isVisible = false
            this.$emit("update:visible", false)
        },
        requestVideoCallModalSubmit() {
            this.loading = true
            this.disableButton = true
            if (!_.isEmpty(this.emailBuilder)) {
                this.$tenant
                    .post(`/api/builder-email`, {
                        email: this.emailBuilder,
                    })
                    .then((response) => {
                        this.loading = false
                        this.disableButton = false
                        this.requestVideoCallModalClose()
                        swal({
                            title: "Success",
                            type: "success",
                            text: "Video Link Sent"
                        })
                    })
                    .catch((error) => {
                        this.loading = false
                        this.disableButton = false
                        this.requestVideoCallModalClose()
                        swal({
                            message: "Video Link Sent Failed",
                            type: "error",
                            title: "Error",
                        })
                    })
            }

            // create application task
            if (_.get(this.emailBuilder, "task.create", false)) {
                this.$store.dispatch("statusIndicators/changeStatus", {
                    stage: "createTask",
                    token: this.$store.getters.token,
                    remindMe: this.$moment(this.emailBuilder.task.remindMe).format("YYYY-MM-DD"),
                    taskName: this.emailBuilder.task.name,
                    time: this.emailBuilder.task.time,
                    userId: this.emailBuilder.task.userId,
                    appId: this.$store.getters.initAppData.id,
                })
            }

            // create recipient tasks
            if (_.get(this.emailBuilder, "recipients", false)) {
                this.emailBuilder.recipients.forEach((recipient) => {
                    if (_.get(recipient, "template.task.create", false)) {
                        this.$store.dispatch("statusIndicators/changeStatus", {
                            stage: "createTask",
                            token: this.$store.getters.token,
                            remindMe: this.$moment(recipient.template.task.remindMe).format("YYYY-MM-DD"),
                            taskName: recipient.template.task.name,
                            time: recipient.template.task.time,
                            userId: recipient.template.task.userId,
                            appId: this.$store.getters.initAppData.id,
                        })
                    }
                })
            }
        },
    },
}
</script>
